<div class="replace-securities-rebalance-settings">
  <div class="flex-row">
    <div class="flex-column flex-column-header"><strong>Allow in:</strong></div>
    <div class="flex-column">
      <div class="checkboxes-horizontal-align">
        <div class="flex-checkbox-item">
          <p-checkbox name="isTaxable" [(ngModel)]="analysisPackage.replaceSecsDto.isTaxable" binary="true"
            (onChange)="onAllowInModified();" [disabled]="isReadOnly"
            inputId="resplacesecitem1">
          </p-checkbox>
          <label for="resplacesecitem1" style="padding-left: .2rem;">Taxable accounts</label>
        </div>
        <div class="flex-checkbox-item">
          <p-checkbox name="isQualified" [(ngModel)]="analysisPackage.replaceSecsDto.isQualified"
            binary="true" (onChange)="onAllowInModified();" [disabled]="isReadOnly"
            inputId="resplacesecitem2">
          </p-checkbox>
          <label for="resplacesecitem2" style="padding-left: .2rem;">Qualified accounts</label>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-row">
    <div class="flex-column flex-column-header flex-search-securities-header">
      <strong>Securities to be Replaced</strong>
    </div>
    <div class="flex-column fixed-width-column">
      <div class="flex-securities-search-container">
        <div class="search-add-container block">
          <div class="search-symbol-header "> Search by symbol</div>
          <div>@if (!isReadOnly) {
            <irb-dropdown-search-multiple #replaceSecDropDown
              [(values)]="replaceSecTargets"
              (search)="getReplaceSecurities($event)"
              [enableHiddenSearchResults]="true"
              [addNewItem]="addNewSecurityItem"
              (openNewItemFlow)="openNewItemSecurityFlow($event, false)"
              (selection)="onReplaceSecChange($event)"
              style="width: 300px !important; vertical-align: middle;"
              size="30">
            </irb-dropdown-search-multiple>
          }
          @if (isReadOnly) {
            <select [disabled]='true' class="select-readonly">
            </select>
          }
        </div>
        <button (click)="addSecurities()" [disabled]="isReadOnly || !disableAddReplaceSec()" class="btn-medium-secondary">Add</button>
        <div>
          @if (toolTipShow) {
            <div class="tooltip">
              <span id="tooltiptext" class="tooltiptext">
                {{tooltipMessage}}
              </span>
            </div>
          }
        </div>
      </div>
      <div class="search-add-container">
        <div class="search-symbol-header">Search by attributes</div>
        <div><button id="advancedFilterButton" (click)="showAddMultipleSecuritiesDialog()" [disabled]="isReadOnly" class="btn-medium-secondary replace-securiries-btn-add-multi">Advanced Filter</button></div>
      </div>
    </div>
  </div>
</div>
<div class="flex-row zero-bottom-margin">
  <div class="flex-column flex-column-header">
    <span><strong>Max Gain Settings</strong></span>
    <span class="tooltipIcon infoIcon" calltoaction
    [calltoactionTemplate]="rebalInfoMaxGainSettings"></span>
  </div>
  <div class="flex-column">
    <div class="flex-max-gain-settings-container">
      <div class="max-gain-settings-row-container">
        Specify values to apply to all securities listed below (optional)
      </div>
      <div class="max-gain-settings-row-container">
        <div class="max-gain-settings-column-container" style="margin-right: 10px">
          <div class="max-gain-settings-header"><strong>ST%</strong></div>
          <div><irb-number-text-box [(value)]="stPercent" [isPercentage]="true" [disabled]="isReadOnly" places="2" width="140px"></irb-number-text-box></div>
          <div><button (click)="updateSTPrec()" [disabled]="isReadOnly || numSec === 0" class="btn-medium-secondary btn-spacer">Apply</button></div>
        </div>
        <div class="max-gain-settings-column-container">
          <div class="max-gain-settings-header">
            <strong>Total%</strong>
          </div>
          <div><irb-number-text-box [(value)]="totalPercent"  [isPercentage]="true" places="2" [disabled]="isReadOnly" width="140px"></irb-number-text-box></div>
          <div><button (click)="updateTotalPrec()" [disabled]="isReadOnly || numSec === 0" class="btn-medium-secondary btn-spacer">Apply</button></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex-row zero-bottom-margin">
  <div class="flex-column flex-column-header"></div>
  <div class="flex-column"><strong>{{numSec}} securities to be replaced</strong></div>
</div>
<div class="flex-row">
  <div class="flex-column flex-column-header"></div>
  <div class="flex-column full-width-grid-column">
    <div style="width: 100%;" id="cr-rebalance-replace-sec-grid">
      @if (!isUiTest) {
        <irb-inventory-grid
          [style.height] = "'100%'"
          [gridHeight] = "'240px'"
          [showSideBar] = "false"
          [gridOptions] = "gridOptions"
          [frameworkComponents] = 'frameworkComponents'
          (gridReady) = "onGridReady($event)"
        ></irb-inventory-grid>
      }</div>
    </div>
  </div>
</div>
<irb-common-dialog #dialog></irb-common-dialog>

<ng-template #rebalInfoMaxGainSettings>
  <div>
    After selecting securities to replace, you can use these settings to quickly
    apply the maximum gain thresholds to all selections, so you don't have to
    enter the same settings for each security. You can edit the settings for any
    individual security after applying these same settings to all.
  </div>
</ng-template>
